import React from "react";
import messiImg from "../assets/images/messi_onboarding.png";
import neymarImg from "../assets/images/neymar_onboarding.png";
import ronaldoImg from "../assets/images/ronaldo_onboarding.png";
import salahImg from "../assets/images/salah_onboarding.png";
import fedeImg from "../assets/images/fede_onboarding.png";
import { mobile_splash_bg } from "../constants/icons";
import { useNavigate } from "react-router-dom";
const MobileSplash = () => {
  const navigate = useNavigate();
  return (
    <div
      className="min-h-screen w-full overflow-x-hidden bg-cover bg-center bg-no-repeat flex flex-col justify-center items-center gap-8 px-4"
      style={{ backgroundImage: `url(${mobile_splash_bg})` }}
    >
      <div className="">
        <svg
          width="49"
          height="48"
          viewBox="0 0 49 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.43135 0H42.5674C45.7944 0 48.4186 2.65967 48.4186 5.85127V42.0227C48.4186 45.2143 45.7944 47.874 42.5674 47.874H6.43135C3.20428 47.874 0.580078 45.2143 0.580078 42.0227V5.85127C0.580078 2.65967 3.20428 0 6.43135 0Z"
            fill="#2283FF"
          />
          <path
            d="M18.9189 16.4473V36.8381H15.2308V16.4473H8.17383V12.7593C16.933 12.7593 25.6922 12.7593 34.4513 12.7593C35.3379 12.7593 36.189 12.9366 36.9337 13.2557C37.7139 13.6104 38.3877 14.0714 38.955 14.6388C39.5224 15.2062 39.9835 15.88 40.3381 16.6601C40.6572 17.4403 40.8345 18.2559 40.8345 19.107V20.2418C40.8345 21.1284 40.6572 21.944 40.3381 22.7242C39.9835 23.4689 39.5224 24.1427 38.955 24.7455C38.3877 25.3129 37.7139 25.7739 36.9337 26.1285C36.189 26.4477 35.3379 26.625 34.4513 26.625H28.0327V36.8736H24.2737V22.866H34.4513C35.1606 22.866 35.7989 22.6178 36.2954 22.0858C36.7919 21.5894 37.0401 20.9865 37.0401 20.2418V19.107C37.0401 18.3623 36.7919 17.7595 36.2954 17.2275C35.7989 16.731 35.1606 16.4828 34.4513 16.4828C29.2739 16.4828 24.0964 16.4473 18.9189 16.4473Z"
            fill="white"
          />
        </svg>
      </div>

      <div>
        <h1 className="text-2xl font-bold text-white text-center break-words max-w-full">
          Welcome to Transferpitch
        </h1>
      </div>

      <div>
        <p className="text-xs text-center text-[#99A1B0]">
          Designed for sports professionals, we ensure faster decisions, smarter
          deals, and a unified space to elevate the transfer experience.
        </p>
      </div>

      <div
        className="w-full max-w-[313px] h-auto min-h-[152px] bg-[rgba(255,255,255,0.1)] rounded-lg border border-[#96A4BE] flex justify-between items-center flex-col gap-3 px-8 py-4"
        style={{
          background: "rgba(255, 255, 255, 0.1)",
          backdropFilter: "blur(5px)",
          borderRadius: "12px",
        }}
      >
        <p className="text-white font-medium text-xs text-center">
          Join 2,000+ clubs and access licensed data on over 1 million players.
        </p>

        <div className="flex items-center justify-center">
          <img src={messiImg} alt="messi" className="w-20 h-20 " />
          <img src={neymarImg} alt="neymar" className="w-20 h-20 -ml-6" />
          <img src={ronaldoImg} alt="ronaldo" className="w-20 h-20 -ml-6" />
          <img src={salahImg} alt="salah" className="w-20 h-20 -ml-6" />
          <img src={fedeImg} alt="fede" className="w-20 h-20 -ml-6" />
        </div>
      </div>

      <div
        onClick={() => navigate("/register")}
        className="w-full flex items-center justify-center"
      >
        <div className="bg-[#2283FF] w-[50%] text-center px-4 py-2 rounded-lg text-sm text-[#F5F5F5]">
          Create account
        </div>
      </div>

      <div onClick={() => navigate("/login")}>
        <p className="text-[#2283FF] text-sm">Login</p>
      </div>
    </div>
  );
};

export default MobileSplash;
